module.exports = __webpack_public_path__ + "static/media/SentinelX_chat_dark.b0b39177.png";